import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/ExclamationmarkSmallTriangleFill.tsx
const ExclamationmarkSmallTriangleFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.768 2.216c-.75-1.425-2.79-1.425-3.54 0L1.886 18.069C1.185 19.4 2.15 21 3.655 21h16.687c1.505 0 2.471-1.6 1.77-2.931L13.77 2.216ZM10.998 12a1 1 0 1 0 2 0V9a1 1 0 1 0-2 0v3Zm1 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
		fill: props.fill || "currentColor"
	})
}));
//#endregion
export { ExclamationmarkSmallTriangleFillIcon };
